import React from 'react'
import { BtnV2, Icon, LinkBtn, l } from '@manychat/manyui'

import { SupportTicketLink } from 'common/core/components/SupportLinks/supportTicketLink'
import { analyticsService } from 'utils/services/analytics'

interface IProps {
  onCancel: () => void
  onSubmit: () => void
}

const SuccessStep = ({ onCancel, onSubmit }: IProps) => {
  const handleGoToSurveyClick = () => {
    analyticsService.sendEvent('SETTINGS.BILLING.CANCEL_SUBSCRIPTION_SUCCESS.SURVEY.CLICK')
    onSubmit()
  }

  return (
    <>
      <div className="p-t-xl p-x row center">
        <Icon.CheckCircle size={72} className="text-success" />
      </div>
      <p className="text-center text-heading m-t-lg">
        {l.translate('You have requested subscription cancellation')}
      </p>
      <div className="p-x-xxl p-b-md">
        <div className="text-secondary text-center m-t-xs">
          {l.translate('We will process your request as soon as possible.')}
        </div>
        <div className="text-secondary text-center m-t-xs">
          {l.translate('Please, tell us more about your experience by sharing a feedback.')}
        </div>
      </div>
      <div className="p-y-xs p-x b-t row between">
        <BtnV2 className="m-l" label="Close" onClick={onCancel} />
        <LinkBtn
          className="m-r"
          variant="primary"
          label={l.translate('Share Feedback')}
          href={SupportTicketLink.PRODUCT}
          target="_blank"
          onClick={handleGoToSurveyClick}
        />
      </div>
    </>
  )
}

export default SuccessStep
